import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService, IdDescription } from '../../../tms-shared';
import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class AddressAddresseeReferenceService extends BaseReferenceService {
  constructor(protected httpService: HttpService) {
    super('AddressAddresseeReference', httpService);
  }

  getForAddress(addressId: string): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/Address/${addressId}`);
  }
}
